import { Injectable } from '@angular/core';
import * as signalR from '@aspnet/signalr';
import { EnvService } from 'src/app/env.service';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { ApiEndPointsNotification } from 'src/app/services/commonUtility/apiUrls/api-end-points-notification';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class HubConnection {
  hubConnection: any;
  private baseUrlTrans:any;
  private baseUrlManagerUsers:any;
  private baseUrlChatRoom:any;
  newChatRecived = new Subject<any>();
  newGroupCreated = new Subject<any>();
  userRemoved = new Subject<any>();

  constructor(private _http: HttpClient,public env: EnvService,private constant: Constants,
    private apiAddress: ApiEndPointsNotification) {
      if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
    this.baseUrlTrans = this.constant.ManageTranscationportNumber;
    else
    this.baseUrlTrans = this.env.apiUrl+this.constant.ManageTranscationportNumber;

    if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
    this.baseUrlManagerUsers = this.constant.ManageUserPortNumber;
    else
    this.baseUrlManagerUsers = this.env.apiUrl+this.constant.ManageUserPortNumber;

    if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
    this.baseUrlChatRoom = this.constant.Chat;
    else
    this.baseUrlChatRoom = this.env.apiUrl+this.constant.Chat;

    this.createHubConnection = this.createHubConnection.bind(this);
  }

  createHubConnection = () => { 
    if(this.hubConnection==null || this.hubConnection==undefined)
    {
      const apiURL = this.baseUrlChatRoom + 'chat';
      this.hubConnection = new signalR.HubConnectionBuilder().withUrl(apiURL+'?diag=yes').build();
  
      this.hubConnection.start().then(() => {    
       }).catch(err => console.log('Error while establishing connection'));
  
       this.hubConnection.on('messageRecieved', (data) => {     
        this.newChatRecived.next(data);    
      });
   

    this.hubConnection.on('groupCreated', (data) => { 
      this.newGroupCreated.next(data);
    });

    this.hubConnection.on('userRemoved', (data) => { 
      this.userRemoved.next(data);
    });
  }
  };

  getHubConnection() {
    return this.hubConnection;
  }

  restartHubConnection() {
    let self = this;
    return new Promise((resolve, reject) => {
      if (self.isDisconnected()) {
        self.hubConnection
          .start()
          .then((hubConnection) => {
            resolve(hubConnection);
          })
          .catch((err) => {          
            reject(err);
          });
       }
    });
  }
  

  isConnected() {
    return(this.hubConnection && this.hubConnection.connection.connectionState === 1);
  }

  isDisconnected() {
    return(this.hubConnection && this.hubConnection.connection.connectionState === 2);
  }
  
  ConnectToServerWithUserId(userId: number, roomId: number) {
    var room = this.hubConnection.invoke("Connect", userId, roomId);
    return room;
  }

  ConnectWithAccessToken() {
    var room = this.hubConnection.invoke("ConnectWithAccessToken");
    return room;
  }

  ConnectWithBussinessToken(userId: number) {
    var room = this.hubConnection.invoke("ConnectWithBussinessToken", userId);
    return room;
  }

  // To get User List for chat
  GetUsersListForChat(data: any): Observable<any> {
    const apiURL = this.baseUrlManagerUsers + this.apiAddress.GetUsersListForChat;
    return this._http.post(apiURL, data).pipe();
  }

  getPortalEmailUserList(data: any): Observable<any> {
    const apiURL = this.baseUrlManagerUsers + this.apiAddress.getPortalEmailUserList;
    return this._http.post(apiURL, data).pipe();
  }

   // Create Chat Room
   CreateChatRoom(data: any): Observable<any> {
    const apiURL = this.baseUrlChatRoom + this.apiAddress.CreateChatRoom;
    return this._http.post(apiURL, data).pipe();
  }

  // Get All Rooms for User
  GetAllRoomsforUser(data: any): Observable<any> {
    const apiURL = this.baseUrlChatRoom + this.apiAddress.GetAllRoomsforUser;
    return this._http.post(apiURL, data).pipe();
  }
 // Get All Rooms for User
 SearchChatOrMessages(data: any): Observable<any> {
  const apiURL = this.baseUrlChatRoom + this.apiAddress.SearchChatOrMessages;
  return this._http.post(apiURL, data).pipe();
}
  // Add Or Remove User From Chat Room
  AddOrRemoveUserFromChatRoom(data: any): Observable<any> {
    const apiURL = this.baseUrlChatRoom + this.apiAddress.AddOrRemoveUserFromChatRoom;
    return this._http.post(apiURL, data).pipe();
  }

  // Create Chat Message
  CreateChatMessage(data: any): Observable<any> {
    const apiURL = this.baseUrlChatRoom + this.apiAddress.CreateChatMessage;
    return this._http.post(apiURL, data).pipe();
  }

  // Get Chat Messages List For Room
  GetChatMessagesListForRoom(data: any): Observable<any> {
    const apiURL = this.baseUrlChatRoom + this.apiAddress.GetChatMessagesListForRoom;
    return this._http.post(apiURL, data).pipe();
  }

  AddfileAsAttachment(data:any):Observable<any>{
    const apiURL =this.baseUrlChatRoom + this.apiAddress.AddFileAsAttachment;
    return this._http.post(apiURL, data).pipe();
  }

  GetAttachementsListForRoomId(data:any):Observable<any>{
    const apiURL =this.baseUrlChatRoom + this.apiAddress.GetAttachementsListForRoomId;
    return this._http.post(apiURL, data).pipe();
  }

  getAttachment(fileName,filePath): Observable<any> {
    const queryParam = '?fileName=' + filePath ;
    const apiURL = this.baseUrlTrans + this.apiAddress.getAttachment + '' + queryParam;
    return this._http.get(apiURL).pipe();
  }
}
